import { formSerializeObject } from './form-serialize-object';

( function( $ ) {

    $( document ).on( 'submit', 'form[id^="gform"]', function( event, bool, buttonID ) {

        let $button = $( '#' + buttonID );

        if ( ! $button.hasClass( 'gform_previous_button' ) ) return;
        
        $button.closest( '.gform_page' ).find( '.gform_page_fields [name]' ).each( function( index, field ) {

            if ( $( field ).is( 'input[type="checkbox"], input[type="radio"]' ) ) {
                $( field ).attr( 'checked', false );
            }
            else {
                $( field ).val( '' );
            }

        } );

        let formID = parseInt( $( this ).attr( 'id' ).replace( 'gform_', '' ) ),
            pageID = parseInt( $button.closest( '.gform_page' ).attr( 'id' ).replace( 'gform_page_' + formID + '_', '' ) );

        $( document ).trigger( 'pws_gform_page_reverted', [ $( this ), formID, pageID ] );

    } );

    $( document ).on( 'gform_page_loaded', function( event, formID, currentPage ) {

        if ( parseInt( currentPage ) !== 7 && parseInt( currentPage ) !== 15 ) return;
        if ( parseInt( formID ) !== 2 ) return;

        let $form = $( '#gform_' + formID );

        $form.find( '.gform_next_button' ).hide();

    } );

    $( document ).on( 'gform_post_render', function( event, formID, currentPage ) {

        if ( parseInt( currentPage ) !== 7 ) return;
        if ( parseInt( formID ) !== 2 ) return;

        let subjectFieldID = 'input_2_26', // Each choice is a variant of this. We need to grab them all
            htmlID = 'field_2_25',
            $form = $( '#gform_' + formID );

        // These are submitted to Gravity Forms without the Form ID
        subjectFieldID = subjectFieldID.replace( '_' + formID, '' );

        let data = formSerializeObject( $form.serializeArray() );

        // Grab only the appropriate values from the previous Page's submission
        data = Object.keys( data ).filter( ( key ) => {
            
            return key.indexOf( subjectFieldID + '.' ) > -1;

        } ).reduce( ( result, key ) => {

            return Object.assign( result, {
                [ key ]: data[ key ]
            } );

        }, {} );

        $.ajax( {
            url: '/wp-json/pws/v1/get-related-courses',
            method: 'GET',
            data: data,
            success : function( response ) {

                $( '#' + htmlID + ' #logic-based-product-list' ).html( response.data.html );

            },
            error : function( request, status, error ) {

                var errorMessage = JSON.parse( request.responseText );

                if ( typeof errorMessage.data.message !== 'undefined' ) {
                    console.error( errorMessage.data.message );
                }
                else if ( typeof errorMessage.message !== 'undefined' ) {
                    console.error( errorMessage.message );
                }

            }
        } );

        // Grab selected option(s) for subjects, send to API endpoint, display links to relevant products based on Pillar

        // Check if the current page is showing the "dynamic field" first so we aren't hitting the API endpoint on every page turn

        // The field should probably get reverted if they go back a page

    } );

    $( document ).on( 'pws_gform_page_reverted', function( event, form, formID, pageID ) {

        if ( parseInt( pageID ) !== 7 ) return;
        if ( parseInt( formID ) !== 2 ) return;

        let htmlID = 'field_2_25';

        $( '#' + htmlID + ' #logic-based-product-list' ).html( '<img id="gform_ajax_spinner_2" class="gform_ajax_spinner" src="/wp-content/plugins/gravityforms/images/spinner.svg" alt="">' );

    } );

} )( jQuery );


// WEBPACK FOOTER //
// ./src/assets/js/lib/multi-page.js